export var config = {
    onError: function (e) { return console.error(e); },
};
export var setConfig = function (conf) {
    Object.assign(config, conf);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/use-sidecar/dist/es2015/config.js
// module id = 371
// module chunks = 0